import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, SpinButton, SpinButtonChangeEvent, SpinButtonOnChangeData } from "@fluentui/react-components";
import { useState } from "react";

export default function ChangeValueDialog(
    {
        valueName,
        valueMax,
        open,
        setOpen,
        callback
    }: {
        valueName: string,
        valueMax: number,
        open: boolean,
        setOpen: (open: boolean) => void,
        callback: ( newValue: number ) => void
    }
) {
    const [ disableOK, setDisableOK ] = useState<boolean>( true );
    const [ currentValue, setCurrentValue ] = useState<number>( 0 );

    const handleInputChange = ( event: SpinButtonChangeEvent ) => {
        const value = parseInt( ( event.target as HTMLInputElement ).value );
        if( value < 0 || value > valueMax ) {
            setDisableOK( true );
        } else {
            setDisableOK( false );
            setCurrentValue( value );
        }
    };

    return (
        <Dialog open={open} onOpenChange={(_, data) => setOpen( data.open )}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>Change {valueName}</DialogTitle>
                    <DialogContent>
                        <SpinButton defaultValue={0} max={valueMax} onChange={handleInputChange} />
                    </DialogContent>
                    <DialogActions>
                        <Button appearance="primary" disabled={disableOK} onClick={ () => {
                            callback( currentValue );
                            setOpen( false );
                        } }>
                            OK
                        </Button>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">Cancel</Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}